"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var stickyfilljs_1 = require("stickyfilljs");

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var IconLink_1 = require("../../molecules/IconLink");

var Sizes;

(function (Sizes) {
  Sizes["AUTO"] = "";
  Sizes["DESKTOP"] = "lsg--processheader__desktop";
  Sizes["MOBILE"] = "lsg--processheader__mobile";
})(Sizes = exports.Sizes || (exports.Sizes = {}));

var ProcessHeader =
/** @class */
function (_super) {
  __extends(ProcessHeader, _super);

  function ProcessHeader() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.uuid = _this.props.id || uniqid_1["default"]("ProcessHeader-");
    return _this;
  }

  ProcessHeader.prototype.componentDidMount = function () {
    // WindowEvents.addStickyElement(this.uuid, this.containerRef);
    stickyfilljs_1.addOne(this.containerRef);
  };

  ProcessHeader.prototype.componentWillUnmount = function () {
    // WindowEvents.removeStickyElement(this.uuid);
    stickyfilljs_1.removeOne(this.containerRef);
  };

  ProcessHeader.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        children = _a.children,
        size = _a.size;
    return React.createElement("div", {
      id: this.uuid,
      className: utils_1.DomUtils.cleanupClassNames([className, CSSPrefix_1.lsgPre + "processheader", CSSPrefix_1.prefixEnumClassNames(size)]),
      ref: function ref(r) {
        _this.containerRef = r;
      }
    }, children);
  };

  ProcessHeader.Sizes = Sizes;

  ProcessHeader.LogoArea = function (_a) {
    var className = _a.className,
        props = __rest(_a, ["className"]);

    return React.createElement("div", __assign({}, props, {
      className: utils_1.DomUtils.cleanupClassNames([className, CSSPrefix_1.lsgPre + "processheader-left"])
    }));
  };

  ProcessHeader.ActionArea = function (_a) {
    var className = _a.className,
        props = __rest(_a, ["className"]);

    return React.createElement(IconLink_1.IconLinkGroup, __assign({}, props, {
      className: utils_1.DomUtils.cleanupClassNames([className, CSSPrefix_1.lsgPre + "processheader-right"]),
      direction: IconLink_1.IconLinkGroup.Directions.COLLAPSE_MD
    }));
  };

  return ProcessHeader;
}(React.Component);

exports.ProcessHeader = ProcessHeader;
ProcessHeader.ActionArea.displayName = "ProcessHeader.ActionArea";